import { Kaggle } from "@kaggle/sdk";

type UserPlan = Kaggle.Sdk.Users.UserPlan;

export const MARKETPLACE_URL =
  "https://console.cloud.google.com/marketplace/product/kaggle-marketplace-public/kaggle-pro";
export const PRO_URL = "/pro";
export const DOCS_URL = "/docs/pro";

export const userPlanToString = (
  userPlan?: UserPlan,
  includeFees?: boolean
) => {
  if (isKagglePro(userPlan)) {
    return `Kaggle Pro${includeFees && " ($10/month)"}`;
  }
  return `Free${includeFees && " (free)"}`;
};

export const isKagglePro = (userPlan: UserPlan | null | undefined) => {
  if (!userPlan) {
    return false;
  }

  // Transpiling for proto enums is broken. This hack is the workaround for both storybook and prod.
  return (userPlan as any) === "kagglePro" || (userPlan as any) === 1;
};

// TODO remove when we have actual copies.
export const DummyText =
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.";
